<template>
    <div class="form-container">
        <h2>Edit Medical Demographics</h2>
        <hr />

        <form @submit.prevent="submitForm">
            <div class="row">
                <div class="col-md-6 mb-2">
                    <label>DOB</label>
                    <input type="date" v-model="form.dob" class="form-control" />
                    <div v-if="errors.dob" class="text-danger small">{{ errors.dob[0] }}</div>
                </div>
                <div class="col-md-6 mb-2">
                    <label>Age</label>
                    <input type="number" v-model="form.age" class="form-control" />
                    <div v-if="errors.age" class="text-danger small">{{ errors.age[0] }}</div>
                </div>

                <div class="col-md-6 mb-2">
                    <label>Gender</label>
                    <select v-model="form.gender" class="form-control">
                        <div v-if="errors.gender" class="text-danger small">{{ errors.gender[0] }}</div>
                        <option disabled value="">Select</option>
                        <option>Male</option>
                        <option>Female</option>
                        <option>Other</option>
                    </select>
                </div>
                <div class="col-md-6 mb-2">
                    <label>Eye Color</label>
                    <input type="text" v-model="form.eye_color" class="form-control" />
                    <div v-if="errors.eye_color" class="text-danger small">{{ errors.eye_color[0] }}</div>
                </div>

                <div class="col-md-6 mb-2">
                    <label>Weight (kg)</label>
                    <input type="number" v-model="form.weight" class="form-control" />
                    <div v-if="errors.weight" class="text-danger small">{{ errors.weight[0] }}</div>
                </div>
                <div class="col-md-6 mb-2">
                    <label>Height (cm)</label>
                    <input type="number" v-model="form.height" class="form-control" />
                    <div v-if="errors.height" class="text-danger small">{{ errors.height[0] }}</div>
                </div>
                <div class="col-md-6 mb-2">
                    <label>BMI</label>
                    <input type="text" v-model="form.bmi" class="form-control" />
                    <div v-if="errors.bmi" class="text-danger small">{{ errors.bmi[0] }}</div>
                </div>

                <div class="col-md-6 mb-2">
                    <label>Marital Status</label>
                    <input type="text" v-model="form.marital_status" class="form-control" />
                    <div v-if="errors.marital_status" class="text-danger small">{{ errors.marital_status[0] }}</div>
                </div>

                <div class="col-md-12 mb-2">
                    <label>Street Address</label>
                    <input type="text" v-model="form.street_address" class="form-control" />
                    <div v-if="errors.street_address" class="text-danger small">{{ errors.street_address[0] }}</div>
                </div>
                <div class="col-md-4 mb-2">
                    <label>City</label>
                    <input type="text" v-model="form.city" class="form-control" />
                    <div v-if="errors.city" class="text-danger small">{{ errors.city[0] }}</div>
                </div>
                <div class="col-md-4 mb-2">
                    <label>State</label>
                    <input type="text" v-model="form.state" class="form-control" />
                    <div v-if="errors.state" class="text-danger small">{{ errors.state[0] }}</div>
                </div>
                <div class="col-md-4 mb-2">
                    <label>Zip</label>
                    <input type="text" v-model="form.zip" class="form-control" />
                    <div v-if="errors.zip" class="text-danger small">{{ errors.zip[0] }}</div>
                </div>

                <div class="col-md-6 mb-2">
                    <label>Phone</label>
                    <input type="text" v-model="form.phone" class="form-control" />
                    <div v-if="errors.phone" class="text-danger small">{{ errors.phone[0] }}</div>
                </div>
            </div>

            <button type="submit" class="btn btn-success mt-3">💾 Save</button>
        </form>
    </div>
</template>

<script>
export default {
    name: 'IopMedicalDemographicForm',
    props: ['iop_medical_print_id'],
    data() {
        return {
            form: {
                iop_medical_print_id: this.iop_medical_print_id,
                dob: '', age: '', gender: '', weight: '', height: '', eye_color: '',
                marital_status: '', street_address: '', city: '', state: '', zip: '',
                phone: '', bmi: ''
            },
            errors: {}
        };
    },

    mounted() {
        this.loadForm();
    },
    methods: {
        async loadForm() {
            try {
                const res = await this.$api.get(`/iop-medical-demographics/${this.iop_medical_print_id}`);
                if (res.data && Object.keys(res.data).length > 0) {
                    this.form = { ...this.form, ...res.data };
                }
            } catch (err) {
                // It's okay if record doesn't exist, we are handling create/edit in same form
            }
        },
        async submitForm() {
            this.errors = {};
            try {
                await this.$api.post(`/iop-medical-demographics`, this.form);
                this.$router.back();
            } catch (err) {
                if (err.response?.data?.errors) {
                    this.errors = err.response.data.errors;
                } else {
                    alert('Failed to save demographic data.');
                }
            }
        }
    }
}
</script>

<style scoped>
label {
    font-weight: 500;
}
</style>